import {
  Building2,
  Download,
  ExternalLink,
  Mail,
  MapPin,
  MoreHorizontal,
  Phone
} from 'lucide-react';
import React from 'react';
import { Button } from '../ui/button';
import { Card } from '../ui/card';
import { Separator } from '../ui/separator';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from '../ui/dropdown-menu';
import { TooltipWrapper, TooltipContent, TooltipTrigger } from '../ui/tooltip';
import { useNavigate } from 'react-router-dom'; // added useNavigate hook
import { ProgressBarCard } from './progress-bar-card';
import LaunchIcon from '@mui/icons-material/Launch';

function formatDate(dateString) {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  });
}

export function CompanyDetailsCard({ selectedApplicationData, statusList }) {
  const navigate = useNavigate(); // initialize navigate hook

  // Calculate progress dynamically
  const currentStepIndex = statusList.findIndex(step => step.isCurrentStatus);
  const totalSteps = statusList.length;
  const progressPercentage = ((currentStepIndex + 1) / totalSteps) * 100;

  return (
    <Card className='p-5 bg-white shadow-md col-span-2'>
      <div className='flex justify-between items-start mb-4'>
        <h3 className='text-base font-semibold flex items-center'>
          <Building2 className='h-4 w-4 mr-2 text-[#FF5533]' />
          Company Details
        </h3>
        <DropdownMenu>
          {/* <DropdownMenuTrigger asChild>
             <Button variant='ghost' size='sm' className='h-8 w-8 p-0 px-0'>
              <MoreHorizontal className='h-4 w-4' />
            </Button> 
          </DropdownMenuTrigger>*/}
          <DropdownMenuContent align='end'>
            <DropdownMenuItem>
              <ExternalLink className='h-4 w-4 mr-2' />
              <a href='/app/details' className='text-inherit no-underline'>
                View Full Profile
              </a>
            </DropdownMenuItem>
            <DropdownMenuItem>
              <Download className='h-4 w-4 mr-2' />
              Export Details
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>

      <div className='space-y-4'>
        <div className='flex items-start gap-3'>
          <div className='w-10 h-10 rounded-full bg-[#FFF0ED] flex items-center justify-center flex-shrink-0'>
            <Building2 className='h-5 w-5 text-[#FF5533]' />
          </div>
          <div className='flex justify-between w-full'>
            <div>
              <h4 className='font-medium'>
                {selectedApplicationData.customer_name || '---'}
              </h4>
              <p className=' text-gray-500'>Manufacturing</p>
            </div>

            <div
              className='flex items-center cursor-pointer text-orange-600 hover:text-orange-800 '
              onClick={() => navigate(`/app/locations/${selectedApplicationData?.application_id}`)}
            >
              <span className='mr-1'>Detailed Analysis</span>
              <LaunchIcon style={{ fontSize: '0.9rem' }} />
            </div>
          </div>
        </div>

        <Separator />

        {/* Business Summary */}
        <div>
          <h4 className=' font-medium mb-2'>Business Summary</h4>
          <p className=' text-gray-700'>
            {selectedApplicationData.application_detailed_summary || '---'}
          </p>
        </div>

        <Separator />

        <div className='grid grid-cols-2 gap-6'>
          <div className='space-y-3 '>
            <div className='flex items-center gap-2'>
              <Phone className='h-4 w-4 text-gray-400 flex-shrink-0' />
              <span>{selectedApplicationData.customer_phone || '---'}</span>
            </div>
            <div className='flex items-center gap-2'>
              <Mail className='h-4 w-4 text-gray-400 flex-shrink-0' />
              <span className='truncate'>
                {selectedApplicationData.customer_email || '---'}
              </span>
            </div>
            <div className='flex items-start gap-2'>
              <MapPin className='h-4 w-4 text-gray-400 flex-shrink-0 mt-0.5' />
              <span className='truncate'>
                {selectedApplicationData.customer_address || '---'}
              </span>
            </div>
          </div>

          <div>
            <h4 className=' font-medium mb-2'>Application Details</h4>
            <div className='grid grid-cols-2 gap-x-4 gap-y-2 '>
              <div>
                <p className='text-sm text-gray-500'>Application ID:</p>
                <p>{selectedApplicationData.application_id || '---'}</p>
              </div>
              <div>
                <p className='text-sm text-gray-500'>Classification:</p>
                <p>
                  {selectedApplicationData.application_classification || '---'}
                </p>
              </div>
              <div>
                <p className='text-sm text-gray-500'>Line of Business:</p>
                <p> {selectedApplicationData.lob || '---'} </p>
              </div>
              <div>
                <p className='text-sm text-gray-500'>Effective Date:</p>
                <p>
                  {selectedApplicationData.effective_date
                    ? formatDate(selectedApplicationData.effective_date)
                    : '---'}
                </p>
              </div>
            </div>
          </div>
        </div>

        <Separator />

        <ProgressBarCard
          currentStepIndex={currentStepIndex}
          totalSteps={totalSteps}
          progressPercentage={progressPercentage}
          statusList={statusList}
        />
      </div>
    </Card>
  );
}
